(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65222,65250],{

/***/ 65222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BestRideShareLawyersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/styles/variables/bestridesharelawyersVariables.module.scss
var bestridesharelawyersVariables_module = __webpack_require__(15466);
var bestridesharelawyersVariables_module_default = /*#__PURE__*/__webpack_require__.n(bestridesharelawyersVariables_module);
;// CONCATENATED MODULE: ./src/components/bestridesharelawyers/logo/index.tsx


function BestRideShareLawyersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "392",
        height: "40",
        fill: "none",
        viewBox: "0 0 392 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_26)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#22394F",
                        d: "M58.185 11.188a7.645 7.645 0 013.338.693c.923.425 1.701 1.11 2.24 1.973.546.907.82 1.952.792 3.011 0 .6-.12 1.194-.351 1.747a4.823 4.823 0 01-.964 1.506 4.014 4.014 0 01-1.33.949 5.677 5.677 0 013.333 2.84c.335.67.507 1.41.502 2.159a5.787 5.787 0 01-.929 3.348 5.712 5.712 0 01-2.47 2.058 8.031 8.031 0 01-3.287.678H49.055V11.188h9.13zm1.185 8.383c.408-.24.743-.588.969-1.004.239-.426.362-.907.356-1.395a2.741 2.741 0 00-.356-1.376 2.58 2.58 0 00-.964-.979 2.64 2.64 0 00-1.36-.351H52.92v5.446H58c.479.012.952-.106 1.37-.341zm.944 8.84c.467-.25.855-.626 1.119-1.085a3.113 3.113 0 00.397-1.586 2.816 2.816 0 00-.407-1.476 2.946 2.946 0 00-1.11-1.07 3.133 3.133 0 00-1.56-.39H52.92v6.023h5.802c.558 0 1.106-.144 1.592-.417zM83.905 25.198H71.542a5.27 5.27 0 00.808 2.183 4.222 4.222 0 001.556 1.41 4.764 4.764 0 004.297-.06 3.227 3.227 0 001.3-1.58h4.06a7.298 7.298 0 01-1.46 2.71 7.58 7.58 0 01-2.625 2.008 8.137 8.137 0 01-10.611-3.459 8.895 8.895 0 010-8.438 8.032 8.032 0 017.142-4.15 7.755 7.755 0 016.963 4.055 8.332 8.332 0 011.003 4.04c.004.362-.02.789-.07 1.28zm-3.724-2.881a3.078 3.078 0 00-.663-1.622 4.15 4.15 0 00-1.506-1.184 4.61 4.61 0 00-2.008-.442 4.547 4.547 0 00-2.67.823 4.222 4.222 0 00-1.626 2.425h8.473zM88.955 31.828a5.365 5.365 0 01-2.294-2.007 5.17 5.17 0 01-.758-2.71h3.574a2.408 2.408 0 00.883 1.836 3.58 3.58 0 002.38.703 3.474 3.474 0 002.108-.532 1.73 1.73 0 00.707-1.47 1.441 1.441 0 00-.371-1.04c-.3-.292-.67-.501-1.074-.607a15.309 15.309 0 00-1.893-.402 8.705 8.705 0 01-4.126-1.476c-1.027-.756-1.54-1.895-1.54-3.418-.02-.902.22-1.79.692-2.56a4.557 4.557 0 012.033-1.711 7.836 7.836 0 013.233-.608 8.181 8.181 0 013.337.643 5.164 5.164 0 012.25 1.792c.535.777.814 1.702.797 2.645l-3.644-.03a1.953 1.953 0 00-.763-1.456 3.137 3.137 0 00-1.963-.547 2.59 2.59 0 00-1.721.502 1.741 1.741 0 00-.326 2.224c.254.282.586.485.953.582.684.21 1.384.363 2.093.457 1.06.141 2.1.399 3.102.768.793.29 1.489.796 2.008 1.46.523.752.783 1.656.738 2.57a4.667 4.667 0 01-.853 2.856 5.099 5.099 0 01-2.344 1.742 9.622 9.622 0 01-3.449.577 8.26 8.26 0 01-3.77-.783zM105.193 30.87c-1.004-.84-1.506-2.428-1.506-4.764v-6.605h-3.278v-3.203h3.278v-4.633l3.724-.03v4.663h4.739v3.203h-4.744v6.77c0 1.838.768 2.756 2.294 2.756h2.45v3.097h-3.218a5.64 5.64 0 01-3.739-1.254zM128.423 11.188a8.033 8.033 0 013.744.854 6.33 6.33 0 012.585 2.404 6.75 6.75 0 01.934 3.564 6.37 6.37 0 01-1.155 3.8 6.208 6.208 0 01-3.107 2.293l4.739 8.032h-4.402l-4.142-7.434h-4.402v7.423h-3.829V11.188h9.035zm1.681 9.838a3.29 3.29 0 001.28-1.234 3.41 3.41 0 00.467-1.782 3.273 3.273 0 00-.467-1.717 3.358 3.358 0 00-1.295-1.23 3.662 3.662 0 00-1.822-.456h-5.05v6.866h5.065a3.708 3.708 0 001.822-.447zM139.174 13.231a2.169 2.169 0 010-3.052 2.31 2.31 0 011.682-.607 2.383 2.383 0 011.711.607 2.172 2.172 0 010 3.057 2.402 2.402 0 01-1.726.603 2.292 2.292 0 01-1.667-.608zm-.165 3.067h3.724v15.826h-3.724V16.298zM149.67 31.482a7.646 7.646 0 01-2.726-3.037 9.653 9.653 0 010-8.458 7.568 7.568 0 012.721-3.041 7.273 7.273 0 014.015-1.125 5.864 5.864 0 012.289.442 6.198 6.198 0 011.832 1.13c.488.43.901.938 1.22 1.505l-.08-1.651V10.45h3.709v21.674h-3.538V29.46a6.354 6.354 0 01-2.194 2.249 6.078 6.078 0 01-3.288.893 7.143 7.143 0 01-3.96-1.12zm6.972-2.967a4.703 4.703 0 001.692-1.797c.419-.769.633-1.633.622-2.51a5.214 5.214 0 00-.612-2.509 4.65 4.65 0 00-1.687-1.782 4.439 4.439 0 00-2.364-.657 4.52 4.52 0 00-4.046 2.404 5.17 5.17 0 00-.617 2.54 5.259 5.259 0 00.602 2.51 4.56 4.56 0 001.662 1.786c.722.44 1.554.667 2.399.653a4.408 4.408 0 002.349-.638zM181.97 25.198h-12.363c.103.779.38 1.525.808 2.183a4.226 4.226 0 001.556 1.41 4.766 4.766 0 004.297-.06 3.228 3.228 0 001.3-1.58h4.061a7.306 7.306 0 01-1.461 2.71 7.581 7.581 0 01-2.625 2.008 8.14 8.14 0 01-10.611-3.459 8.889 8.889 0 010-8.438 8.031 8.031 0 017.143-4.17 7.741 7.741 0 016.962 4.075 8.33 8.33 0 011.003 4.04c.004.362-.02.789-.07 1.28zm-3.724-2.881a3.041 3.041 0 00-.663-1.622 4.15 4.15 0 00-1.506-1.184 4.604 4.604 0 00-2.007-.442 4.549 4.549 0 00-2.691.808 4.22 4.22 0 00-1.626 2.424l8.493.016zM187.02 31.828a5.362 5.362 0 01-2.294-2.007 5.164 5.164 0 01-.758-2.71h3.574a2.41 2.41 0 00.883 1.837 3.6 3.6 0 002.379.702 3.471 3.471 0 002.108-.532 1.725 1.725 0 00.708-1.47 1.424 1.424 0 00-.371-1.04c-.3-.292-.67-.501-1.074-.607a15.314 15.314 0 00-1.893-.402 8.707 8.707 0 01-4.126-1.476c-1.03-.756-1.544-1.895-1.541-3.418a4.704 4.704 0 01.693-2.56 4.555 4.555 0 012.008-1.711 7.833 7.833 0 013.232-.608 8.178 8.178 0 013.338.643 5.167 5.167 0 012.249 1.792 4.51 4.51 0 01.843 2.62h-3.664a1.941 1.941 0 00-.763-1.456 3.137 3.137 0 00-1.963-.542 2.589 2.589 0 00-1.721.502 1.745 1.745 0 00-.326 2.224c.254.282.586.485.953.582.684.21 1.384.363 2.093.457 1.059.141 2.1.399 3.102.768.793.29 1.488.796 2.008 1.46.525.751.786 1.655.743 2.57a4.671 4.671 0 01-.858 2.856 5.103 5.103 0 01-2.344 1.742 9.627 9.627 0 01-3.449.577 8.259 8.259 0 01-3.769-.793zM204.226 10.45v6.45l-.09 1.772a5.392 5.392 0 012.138-2.088 6.474 6.474 0 013.168-.763c2.101 0 3.687.67 4.758 2.008 1.071 1.339 1.605 3.263 1.601 5.772v8.534h-3.724v-8.463c0-1.506-.321-2.636-.954-3.348a3.44 3.44 0 00-2.71-1.07 3.794 3.794 0 00-2.053.608 4.465 4.465 0 00-1.551 1.702 5.202 5.202 0 00-.583 2.48v8.08h-3.734V10.45h3.734zM222.577 31.477a7.702 7.702 0 01-2.675-3.047 9.575 9.575 0 010-8.422 7.89 7.89 0 012.68-3.052 6.626 6.626 0 013.775-1.135 6.964 6.964 0 013.443.839 5.575 5.575 0 012.269 2.319v-2.68h3.559v15.825h-3.539V29.46a5.522 5.522 0 01-2.268 2.31 6.939 6.939 0 01-3.429.832 6.78 6.78 0 01-3.815-1.124zm7.028-2.977a4.705 4.705 0 001.686-1.786 5.18 5.18 0 00.613-2.51 5.08 5.08 0 00-.623-2.51 4.787 4.787 0 00-1.686-1.792 4.328 4.328 0 00-2.339-.662 4.516 4.516 0 00-4.016 2.369 5.684 5.684 0 000 5.19c.392.72.978 1.317 1.692 1.722a4.635 4.635 0 002.324.602 4.453 4.453 0 002.349-.623zM243.554 16.298v2.866a4.757 4.757 0 011.651-2.103 4.413 4.413 0 012.595-.763h1.692v3.203h-1.506a4.097 4.097 0 00-2.249.617 4.023 4.023 0 00-1.506 1.802 6.798 6.798 0 00-.542 2.846v7.358h-3.724V16.298h3.589zM266.533 25.198H254.17c.103.779.379 1.525.808 2.183a4.226 4.226 0 001.556 1.41 4.764 4.764 0 004.297-.06 3.234 3.234 0 001.3-1.58h4.06a7.29 7.29 0 01-1.46 2.71 7.581 7.581 0 01-2.625 2.008 8.143 8.143 0 01-10.611-3.459 8.89 8.89 0 010-8.438 8.024 8.024 0 017.142-4.17 7.739 7.739 0 016.962 4.075 8.331 8.331 0 011.004 4.04c.003.362-.02.789-.07 1.28zm-3.725-2.881a3.013 3.013 0 00-.662-1.622 4.117 4.117 0 00-1.506-1.184 4.609 4.609 0 00-2.008-.442 4.547 4.547 0 00-2.67.823 4.22 4.22 0 00-1.626 2.425h8.472zM273.846 11.188h3.835v17.503h9.447v3.433h-13.282V11.188zM291.996 31.477a7.758 7.758 0 01-2.66-3.067 9.617 9.617 0 010-8.423 7.89 7.89 0 012.68-3.051 6.66 6.66 0 013.78-1.135 6.945 6.945 0 013.438.839 5.617 5.617 0 012.274 2.319v-2.68h3.514v15.845h-3.514V29.46a5.521 5.521 0 01-2.274 2.31 6.915 6.915 0 01-3.423.832 6.763 6.763 0 01-3.815-1.124zm7.028-2.977a4.705 4.705 0 001.686-1.787 5.33 5.33 0 000-4.989 4.83 4.83 0 00-1.686-1.792 4.34 4.34 0 00-2.339-.662 4.52 4.52 0 00-4.016 2.369 5.207 5.207 0 00-.622 2.575c-.02.911.196 1.812.627 2.615.394.72.982 1.317 1.697 1.722a4.62 4.62 0 002.324.602 4.447 4.447 0 002.339-.653h-.01zM307.371 16.298h4.016l3.092 10.039.281.939h.045l.291-.939 3.012-10.039h2.755l2.892 9.929.326 1.049h.045l.371-1.11 3.092-9.868h3.911l-5.351 15.826H322.7l-3.292-10.24-3.343 10.255h-3.353l-5.341-15.84zM335.013 34.433c.462.015.922-.074 1.345-.26.365-.183.673-.46.894-.804.293-.458.533-.948.718-1.46l.185-.537-6.063-15.089h3.925l3.724 9.617.397 1.632.397-1.632 3.664-9.577h3.97l-6.129 15.445a15.422 15.422 0 01-1.862 3.594 4.957 4.957 0 01-2.098 1.697c-.966.34-1.988.499-3.012.466h-2.66v-3.092h2.605zM364.934 25.198h-12.353a5.14 5.14 0 00.803 2.208 4.226 4.226 0 001.556 1.41c.619.328 1.308.5 2.008.503a4.279 4.279 0 002.269-.543 3.195 3.195 0 001.3-1.58h4.066a7.306 7.306 0 01-1.461 2.71 7.63 7.63 0 01-2.625 2.008 8.147 8.147 0 01-10.601-3.504 8.935 8.935 0 010-8.438 8.031 8.031 0 017.142-4.17 7.756 7.756 0 016.967 4.075 8.32 8.32 0 011.004 4.04c-.001.428-.026.856-.075 1.28zm-3.724-2.882a3.014 3.014 0 00-.663-1.62 4.067 4.067 0 00-1.506-1.185 4.755 4.755 0 00-4.678.381 4.236 4.236 0 00-1.621 2.424h8.468zM371.615 16.298v2.866a4.807 4.807 0 011.656-2.103 4.404 4.404 0 012.595-.763h1.692v3.203h-1.506a3.928 3.928 0 00-3.754 2.419c-.38.9-.563 1.87-.537 2.846v7.358h-3.725V16.298h3.579zM381.543 31.828a5.394 5.394 0 01-2.293-2.007 5.202 5.202 0 01-.753-2.71h3.568a2.394 2.394 0 00.889 1.836c.682.51 1.524.76 2.374.703a3.472 3.472 0 002.108-.532 1.726 1.726 0 00.708-1.47 1.462 1.462 0 00-.366-1.04 2.444 2.444 0 00-1.08-.607 15.278 15.278 0 00-1.892-.402 8.746 8.746 0 01-4.126-1.476c-1.024-.756-1.536-1.895-1.536-3.418-.02-.902.221-1.79.693-2.56a4.516 4.516 0 012.008-1.711 7.852 7.852 0 013.232-.608 8.195 8.195 0 013.343.643 5.15 5.15 0 012.244 1.792c.537.776.818 1.701.803 2.645l-3.649-.03a1.94 1.94 0 00-.763-1.456 3.139 3.139 0 00-1.963-.542 2.602 2.602 0 00-1.722.502 1.733 1.733 0 00-.321 2.224c.254.284.586.486.954.582.684.21 1.384.363 2.093.457 1.067.134 2.115.385 3.127.748.793.29 1.488.796 2.008 1.46.523.752.783 1.656.738 2.57a4.704 4.704 0 01-.853 2.856 5.139 5.139 0 01-2.35 1.742 9.579 9.579 0 01-3.448.577 8.282 8.282 0 01-3.775-.768z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#22394F",
                        fillRule: "evenodd",
                        d: "M36.04 24.34a16.66 16.66 0 01-11.982 11.775 1.359 1.359 0 01-1.686-1.315v-1.872a1.356 1.356 0 01.462-1.004 24.811 24.811 0 005.34-6.767c.413-.767.784-1.556 1.11-2.364a1.35 1.35 0 011.43-.833c1.47.19 2.896.418 4.282.683a1.356 1.356 0 011.044 1.691M15.962 36.11A16.66 16.66 0 013.98 24.334a1.356 1.356 0 011.044-1.691 64.688 64.688 0 014.282-.683 1.35 1.35 0 011.43.833 24.531 24.531 0 006.436 9.13 1.37 1.37 0 01.456 1.005v1.857a1.36 1.36 0 01-1.686 1.315M3.85 16.077a16.62 16.62 0 0132.3 0 1.355 1.355 0 01-1.55 1.657 90.012 90.012 0 00-2.455-.382 1.36 1.36 0 01-1.165-1.48c.05-.502.085-1.004.1-1.506l.036-1.004-11.113-3.564-11.119 3.554.036 1.004c0 .502.05 1.004.1 1.505a1.36 1.36 0 01-1.165 1.481c-.828.116-1.646.246-2.454.382a1.359 1.359 0 01-1.551-1.662M20.002-.03a20.002 20.002 0 10-.01 40.005 20.002 20.002 0 00.01-40.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#A2C23A",
                        fillRule: "evenodd",
                        d: "M20.034 29.916a21.182 21.182 0 01-7.59-14.12l7.59-2.444 7.584 2.43a21.203 21.203 0 01-7.584 14.134z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_26)",
                        d: "M27.584 15.763L20 13.333v16.565a21.202 21.202 0 007.584-14.135z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_26",
                        x1: "27.966",
                        x2: "18.188",
                        y1: "18.204",
                        y2: "24.426",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.04",
                                stopColor: "#A2C23A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#66752A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_26",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H391.949V40H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var logo = (BestRideShareLawyersLogo);

// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/bestridesharelawyersWrapper.tsx










const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function BestRideShareLawyersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Ride Share",
                    domain: "BestRideShareLawyers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Ride Share",
                    domain: "BestRideShareLawyers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Open+Sans:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Lato', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: `The Best Ride Share Lawyers  ${region ? `In ${region}` : ""}`,
                        textColor: (bestridesharelawyersVariables_module_default()).sloganColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 15466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sloganColor":"#686868","progressBarColor":"#b0b0b0"};

/***/ })

}]);